module.exports = __webpack_public_path__ + "393db96df8cfb6bbb9d4b6052c59f5c1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/annotated-example-2.png
// module id = 1716
// module chunks = 0